/**
 * Dispara la vectorizacion en la/las Raspberry de la LAN segun lo que devuelva addEvent en
 * `data.localVectorizations` (ip/endpoint/token + imageData).
 *
 * Espejo de passapp-totem/src/lib/raspberryVectorize.ts. Alla el POST lo hace el proceso main
 * de Electron; aca lo hace el service worker de la extension. La forma es la misma:
 * fire-and-forget, se llama desde el unico punto por donde pasa addEvent, y dispara en
 * CUALQUIER addEvent que traiga targets sin importar el caso.
 *
 * No bloquea nada y no puede romper el flujo: no se awaitea y no lanza nunca.
 */
import { AddEventResponse } from "../passapp-sdk/types/eventTypes";
import { postToRaspberry, RASPBERRY_PORT } from "./raspberryBridge";
import {
  recordRaspberryFailure,
  recordRaspberrySuccess,
  recordRaspberryTarget,
} from "./raspberryDiagnostics";

export function dispatchLocalVectorizations(response: AddEventResponse | undefined): void {
  const localVectorizations = response?.data?.localVectorizations;
  const targets = localVectorizations?.vectorizations ?? [];

  if (!targets.length) {
    // Caso normal en edificios sin Raspberry: no es un error, no ensuciamos con warn.
    console.info(
      `[RB] addEvent sin targets (localVectorizations ${
        localVectorizations ? "presente pero vectorizations=[]" : "ausente"
      }) -> no se llama a ninguna Pi`
    );
    return;
  }

  const imageData = localVectorizations?.imageData;
  if (!imageData) {
    console.warn(
      `[RB] addEvent trajo ${targets.length} target(s) pero SIN imageData -> no se puede vectorizar`
    );
    return;
  }

  const urls = targets.map((t) => `http://${t.ip}:${RASPBERRY_PORT}${t.endpoint}`);
  console.info(
    `[RB] addEvent trajo ${targets.length} target(s): ${urls.join(", ")} - imagen ${
      imageData.length
    } chars - llamando...`
  );

  targets.forEach((target) => {
    const request = {
      ip: target.ip,
      port: RASPBERRY_PORT,
      path: target.endpoint,
      token: target.token,
    };
    // Se guarda antes de intentar, asi "Probar conexion" funciona aun si el envio falla.
    recordRaspberryTarget(request);

    void postToRaspberry({ ...request, imageData })
      .then((result) => {
        if (result.ok) {
          console.info("[RB] resultado vectorize", result);
          recordRaspberrySuccess();
          return;
        }
        console.warn("[RB] fallo vectorize", result);
        recordRaspberryFailure(result.errorCode ?? "unknown", result.error ?? "Error desconocido");
      })
      // postToRaspberry esta escrita para no rechazar nunca, pero sin este catch un reject
      // inesperado quedaria como unhandled rejection y el aviso al guardia no se prenderia.
      .catch((error) => {
        console.error("[RB] error inesperado llamando al puente", error);
        recordRaspberryFailure("unknown", String(error?.message || error));
      });
  });
}
